import { render, staticRenderFns } from "./scrollTop.vue?vue&type=template&id=65625470&scoped=true&"
import script from "./scrollTop.vue?vue&type=script&lang=js&"
export * from "./scrollTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65625470",
  null
  
)

export default component.exports